import { useCallback, useEffect, useState } from 'react';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { copyToClipboard } from '#src/app/shared/utils/clipboard';

const COPIED_FEEDBACK_DURATION_MS = 2000;

type Result = ModelHookResult<{ copied: boolean }, { copyValue: () => Promise<void> }>;

export function useStaffDrawerInfo(value: string): Result {
	const { i18n } = useUtilityContext();
	const [copied, setCopied] = useState(false);

	useEffect(() => {
		if (!copied) return undefined;
		const timeout = setTimeout(() => setCopied(false), COPIED_FEEDBACK_DURATION_MS);
		return () => clearTimeout(timeout);
	}, [copied]);

	const copyValue = useCallback(async () => {
		setCopied(await copyToClipboard(value, i18n));
	}, [value, i18n]);

	return {
		data: { copied },
		actions: { copyValue },
	};
}
